<template>
    <ui-modal :load="loading" name="online-sign-integration" icon="-" :data-ui-cancel-button="'button-close-modal'">
        <template #title>
            <div class="modal-title">
                <em class="fal fa-cog" />

                <span class="title">Integração com Assine Online</span>
            </div>
        </template>

        <template>
            <div class="content-body">
                <div v-if="!status" class="access-data">
                    <div class="access-input">
                        <ui-input
                            v-model="form.data.user"
                            :required="form.fields.user.required"
                            label="Login:"
                            placeholder="Login"
                            size="md"
                            :data-ui="'input-user-integration-digital-signature'"
                        />

                        <ui-input
                            v-model="form.data.pass"
                            :required="form.fields.pass.required"
                            type="password"
                            label="Senha:"
                            placeholder="Senha"
                            size="md"
                            :data-ui="'input-pass-integration-digital-signature'"
                        />
                    </div>

                    <div class="access-info">
                        <span>Seu acesso será criptografado ao ser salvo e nunca será exibido.</span>
                    </div>
                </div>

                <div v-else class="integration-status">
                    <label>Status:</label>

                    <div class="integration-message">
                        <div class="oval" />

                        <span>
                            Assine Online está conectado
                        </span>
                    </div>

                    <div class="remove-integration">
                        <span @click="remove">Remover Integração</span>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <span class="cancel" @click="close" data-ui="button-cancel-integration-digital-signature">
                Cancelar
            </span>

            <ui-button v-if="!status" design="primary md mw-100" @click="save" :data-ui="'button-save-integration-digital-signature'">
                Salvar
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput } from '@/components/ui/form'

    import { mapActions } from 'vuex'

	export default {
		name: 'ui-online-sign-integration',

		components: {
			uiModal,
			uiButton,
            uiInput
		},

        data() {
            return {
                form: {
                    data: {
                        user: '',
                        pass: '',
                        active: 1
                    },
                    fields: {
                        user: {
                            required: true
                        },
                        pass: {
                            required: true
                        }
                    }
                },
                status: false,
                loading: false
            }
        },

        created() {
            this.$root.$on('modal-open-online-sign-integration', () => {
                this.loading = true
                this.authenticate()
                    .then(response => {
                        this.status = response.data.data
                    })
                    .catch(error => {
                        if (error?.data?.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                        this.status = false
                    })
                    .finally(() => {
                        this.loading = false
                    })
            })
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'integrate',
                'authenticate',
                'desintegrate'
            ]),
            /**
             * Envia os dados necessários para a integração para o backend, de modo
             * que as medidas de segurança sejam tomadas e as informações sejam salvas
             */
            save: async function () {
                try {
                    this.loading = true
                    let response = await this.integrate(this.form.data)
                    this.$toastr.s(response.data.msg)
                    response = await this.authenticate()
                    this.status = response.data.data

                } catch (error) {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.loading = false
                }
            },
            /**
             * Remove as configurações da integração atual
             */
            remove() {
                this.loading = true
                this.desintegrate()
                    .then(() => {
                        this.status = false
                        this.close()
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            /**
             * Fecha o modal de autenticação
             */
            close() {
                this.$root.$emit('modal-close-online-sign-integration')
            }
        }
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>